export const roundDecimals = num => Math.round(num * 2) / 2;

export const oneDecimal = num => Math.round(num * 10) / 10;

export const percent = (num1, num2) => Math.round((num1 * 100) / num2);

export const getDecimalAsInt = num => Math.round((num % 1) * 10);
